<button [disabled]="isDisabled()" [type]="type"
        [ngClass]="['btn btn-primary connexion', 'background-' + color, size, customButtonClass || '']">
  <div [@fade]="loading ? 'loading': 'idle'" class="anim button-content">
    <i *ngIf="loading" class="active icon fa fa-spin fa-circle-notch"></i>
    <i *ngIf="icon && !loading" [ngClass]="[color, 'fa fas', icon]"></i>
    <span class="label">{{ label | translate }}</span>
  </div>
</button>
